import { render } from "./DangCardGraded.vue?vue&type=template&id=7975019c&scoped=true"
import script from "./DangCardGraded.vue?vue&type=script&lang=js"
export * from "./DangCardGraded.vue?vue&type=script&lang=js"

import "./DangCardGraded.vue?vue&type=style&index=0&id=7975019c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7975019c"]])

export default __exports__